import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IsolatedCoroutineScopensqylcikdcw7 as IsolatedCoroutineScope } from '../../../kotlin-js/js/coroutines/internal/IsolatedCoroutineScope.mjs';
import { CoroutineStart_UNDISPATCHED_getInstanceldihd7d5m0an as CoroutineStart_UNDISPATCHED_getInstance } from '../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CleanupScope28orczoi9dcjw as CleanupScope } from '../CleanupScope.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function runIsolatedJob(block) {
  var cleanup = {_v: null};
  var saveCleanup = (value) => {
    // Inline function 'kotlin.require' call
    if (!(cleanup._v == null)) {
      var message = 'Cleanup already set!';
      throw IllegalArgumentException().s2(toString(message));
    }
    cleanup._v = value;
    return Unit_instance;
  };
  var tmp = IsolatedCoroutineScope();
  var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
  var job = launch(tmp, VOID, tmp_0, runIsolatedJob$slambda_0(block, saveCleanup));
  return () => {
    var tmp0_safe_receiver = cleanup._v;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    job.px();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.s1m_1(new (CleanupScope())($this$launch, $this.t1m_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var runIsolatedJob$slambdaClass;
function runIsolatedJob$slambda() {
  if (runIsolatedJob$slambdaClass === VOID) {
    class $ {
      constructor($block, $saveCleanup) {
        this.s1m_1 = $block;
        this.t1m_1 = $saveCleanup;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    runIsolatedJob$slambdaClass = $;
  }
  return runIsolatedJob$slambdaClass;
}
function runIsolatedJob$slambda_0($block, $saveCleanup) {
  var i = new (runIsolatedJob$slambda())($block, $saveCleanup);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  runIsolatedJob as runIsolatedJob2ho1zf4fsdg8q,
};
//endregion

//# sourceMappingURL=runIsolatedJob.mjs.map
